
  import {Component, Vue} from "vue-property-decorator";
  import breadcrumb from "@/components/common/breadcrumb.vue";
  import {getStationList, getConfig, updatePixel, updateDomain} from '@/services/api'
  import store from "@/store";
  import {StaticPage} from "@/model/StaticPage";

  @Component({
    components: {'zf-breadcrumb': breadcrumb},
  })
  export default class EditList extends Vue {
    // 控制列表高度
    public tableHeight = window.innerHeight - 180;
    // 地区列表
    public countryList: {code: string, name: string}[] = [];
    // 投手列表
    public createrList: {code: string, name: string}[] = [];
    // 上传表单
    public formData: {
      country?: string,
      title?: string,
      pixel?: string,
      pixelGG?: string,
      creater?: string,
      domain?: string,
      itemId?: number,
      pageNo: number,
      pageSize: number
    } = {
      pageNo: 1,
      pageSize: 20
    }
    // 列表总数
    public totalNum = 0
    // 列表数据
    public tableData: StaticPage[] = []

    /**
     * 初始化方法
     */
    async created(): Promise<void> {
      window.onresize = () => {
        try {
          this.tableHeight = window.innerHeight - 180;
        } catch (e) {}
      }
      await this.getStationList();
      this.getConfig();
    }

    /**
     * 获取item列表
     */
    async getStationList(): Promise<void> {
      await getStationList(this.formData, true).then(res => {
        if (res.data && res.data.status === 'OK') {
          this.tableData = res.data.result.results || [];
          this.totalNum =  res.data.result.totalNum || 0;
        }
      }).catch(() => {})
    }

    /**
     * 获取字典信息
     */
    getConfig(): void {
      if (!this.$store.state.region || this.$store.state.region.length === 0) {
        getConfig({type: 'region'}).then(res => {
          if (res.data && res.data.status === 'OK') {
            this.countryList = res.data.result || [];
            store.commit('SET_REGION', this.countryList);
          }
        })
      } else {
        this.countryList = this.$store.state.region;
      }
      if (!this.$store.state.toushou || this.$store.state.toushou.length === 0) {
        getConfig({type: 'toushou'}).then(res => {
          if (res.data && res.data.status === 'OK') {
            this.createrList = res.data.result || [];
            store.commit('SET_TOUSHOU', this.createrList);
          }
        })
      } else {
        this.createrList = this.$store.state.toushou;
      }
    }

    /**
     * 查询
     */
    search(): void {
      this.formData.pageNo = 1;
      this.getStationList();
    }

    /**
     * 分页大小变化
     * @param val
     */
    handleSizeChange(val: number): void {
      this.formData.pageSize = val;
      this.formData.pageNo = 1;
      this.getStationList();
    }

    /**
     * 当前页面变化
     * @param val
     */
    handleCurrentChange(val: number): void {
      this.formData.pageNo = val;
      this.getStationList();
    }

    /**
    * 下面为添加交互
    * selectedList 选中的列表
    */
    public selectedList:any[] = [];

    /**
    * 选择变化钩子
    * @param selectedList
    */
    handleSelectionChange(selectedList: any[]) {
      this.selectedList = selectedList;
    }

    add() {
      this.$emit('add', this.selectedList);
    }

    updatePixel(field: 'pixel' | 'pixelGG', reg: RegExp): void {
      if (this.selectedList.length == 0) {
        this.$message.error("没有选中要操作的元素");
        return;
      }

      let ids: number[] = [];
      for (let data of this.selectedList) {
        ids.push(data.id);
      }

      this.$prompt('请输入像素', '提示', {
        inputPattern: reg,
        inputErrorMessage: '像素格式不正确',
        confirmButtonText: '保存',
        cancelButtonText: '取消'
      }).then(({value}: any) => {
        const params: {staticPagesIds: number[], pixel?: string, pixelGG?: string} = {staticPagesIds: ids};
        params[field] = value;
        updatePixel(params, true).then(res => {
          if (res.data && res.data.status === 'OK') {
            this.$message.success('修改成功');
            this.getStationList();
          }
        });
      }).catch(() => {});
    }

    updateDomain(): void {
      if (this.selectedList.length == 0) {
        this.$message.error("没有选中要操作的元素");
        return;
      }

      let ids: number[] = [];
      for (let data of this.selectedList) {
        ids.push(data.id);
      }

      this.$prompt('请输入域名', '提示', {
          inputPattern: new RegExp('^(?=^.{3,255}$)[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+$'),
          inputErrorMessage: '域名格式不正确',
          confirmButtonText: '保存',
          cancelButtonText: '取消'
      }).then(({value}: any) => {
          const params: {staticPagesIds: number[], domain: string} = {staticPagesIds: ids, domain: value};
          updateDomain(params, true).then(res => {
              if (res.data && res.data.status === 'OK') {
                  this.$message.success('修改成功');
                  this.getStationList();
              }
          });
      }).catch(() => {});
    }

    /**
     * 打开新链接图片
     * @param url
     */
    openImg(url: string): void {
      window.open(url, '_blank');
    }

    /**
     * 打开新的窗口
     */
    openWindow(url: string): void {
      window.open(url,'_blank')
    }
  }

